import React from 'react';
import PropTypes from 'prop-types';

var MobileSubmenu = function MobileSubmenu(_ref) {
  var link = _ref.link,
      LinkTemplate = _ref.LinkTemplate,
      onItemSelected = _ref.onItemSelected;
  return /*#__PURE__*/React.createElement("div", {
    className: "menu__mobile-submenu"
  }, link.subLinks.map(function (sublink, index) {
    return /*#__PURE__*/React.createElement(LinkTemplate, {
      onClick: function onClick() {
        return onItemSelected(index, sublink);
      },
      key: sublink.text,
      className: "menu__mobile-subitem link",
      url: sublink.url
    }, /*#__PURE__*/React.createElement("span", {
      className: "link__content"
    }, sublink.text));
  }));
};

MobileSubmenu.propTypes = {
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }),
  onItemSelected: PropTypes.func,
  LinkTemplate: PropTypes.func
};
export default MobileSubmenu;